
const ACCORDION_OFFSET = 300;
const SCROLL_DELAY = 300;

const accordionToggles = document.querySelectorAll(
  '.wp-block-accordion .wp-block-accordion-heading__toggle'
);

const scrollToAccordionItem = ( button ) => {
  const accordionItem = button.closest( '.wp-block-accordion-item' );

  if ( !accordionItem ) {
    return;
  }

  const itemTop = accordionItem.getBoundingClientRect().top + window.scrollY;

  window.scrollTo( {
    top: itemTop - ACCORDION_OFFSET,
    behavior: 'smooth',
  } );
};

accordionToggles.forEach( ( button ) => {
  button.addEventListener( 'click', () => {
    setTimeout( () => {
      scrollToAccordionItem( button );
    }, SCROLL_DELAY );
  } );
} );

